import { ActionType, getType } from 'typesafe-actions';

import * as buffer from '../../actionCreators/buffer';

const initialState = null;

export default function (
  state: TokenisedAddress | null = initialState,
  action: ActionType<typeof buffer>,
): TokenisedAddress | null {
  switch (action.type) {
    case getType(buffer.clearBuffer): {
      return initialState;
    }
    case getType(buffer.setBufferDeliveryAddress): {
      const { value } = action.payload;
      return value || initialState;
    }
    default:
      return state;
  }
}
